var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { useTranslate } from 'ra-core';
import Fab from '@material-ui/core/Fab';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
export const HomePageCreateButton = (_a) => {
    var { onClick, className } = _a, rest = __rest(_a, ["onClick", "className"]);
    const translate = useTranslate();
    const classes = useStyles(rest);
    return (React.createElement(Tooltip, { title: translate('ra.action.create') },
        React.createElement(Fab, { "aria-label": translate('ra.action.create'), className: classnames(classes.root, className), onClick: onClick },
            React.createElement(AddIcon, null))));
};
export const HomePageEditButton = (_a) => {
    var { onClick, className } = _a, rest = __rest(_a, ["onClick", "className"]);
    const translate = useTranslate();
    const classes = useStyles(rest);
    return (React.createElement(Tooltip, { title: translate('ra.action.edit') },
        React.createElement(Fab, { "aria-label": translate('ra.action.edit'), className: classnames(classes.root, className), onClick: onClick },
            React.createElement(EditIcon, null))));
};
const useStyles = makeStyles(theme => {
    const appBarHeight = theme.spacing(9); // AppBar (size + margin)
    const homePagePadding = theme.spacing(3); // HomePage (padding)
    return {
        root: {
            position: 'fixed',
            right: homePagePadding,
            top: `calc(${appBarHeight}px + ${homePagePadding}px)`,
        },
    };
}, {
    name: 'Layer7HomePageButton',
});
//# sourceMappingURL=HomePageButton.js.map